import { render, staticRenderFns } from "./PageBlock_Publishable.vue?vue&type=template&id=9a7b5216"
import script from "./PageBlock_Publishable.vue?vue&type=script&lang=js"
export * from "./PageBlock_Publishable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports